import { createReducer } from '@reduxjs/toolkit';

import { updateItemAndGetArrayImmutably } from '@qwealth/qcore';

import { Activity } from '../models/Activity';
import {
  setLoading,
  putActivity,
  putActivities,
  deleteHouseholdActivity,
  resetHouseholdActivities,
  deleteHouseholdTaskActivity,
  createHouseholdTaskActivity,
  updateHouseholdTaskActivity,
} from '../actions/householdActivities';
import { isQTask } from 'data/helpers/taskHelper';

interface State {
  isLoading: boolean;
  all: Array<Activity>;
}

const initialState: State = {
  all: [],
  isLoading: false,
};

export default createReducer(initialState, builder => {
  builder.addCase(setLoading, (state, action) => ({ ...state, isLoading: action.payload }));

  builder.addCase(putActivity, (state, action) => {
    const activity = action.payload;

    let activityId: string | number;

    if ('uuid' in activity && !('id' in activity)) {
      activityId = activity.uuid as string;
    } else if ('id' in activity) {
      activityId = activity.id as number;
    }

    const all = updateItemAndGetArrayImmutably(
      state.all,
      u => u.id === activityId || u.uuid === activityId,
      targetItem => (targetItem ? { ...targetItem, ...activity } : activity),
    );
    return { ...state, all };
  });

  builder.addCase(putActivities, (state, action) => ({ ...state, all: action.payload }));

  builder.addCase(deleteHouseholdActivity, (state, action) => {
    if (!action.payload) return state;
    return {
      ...state,
      all: state.all.filter(item => {
        if ('id' in item) {
          return item.id !== action.payload.id;
        } else if ('uuid' in item) {
          return item.uuid !== action.payload.uuid;
        }
        return true;
      }),
    };
  });

  builder.addCase(createHouseholdTaskActivity, (state, action) => {
    if (!action.payload) return state;
    const filteredTasks = state.all.filter(item => !isQTask(item));
    return {
      ...state,
      all: [...filteredTasks, ...action.payload],
    };
  });

  builder.addCase(updateHouseholdTaskActivity, (state, action) => {
    if (!action.payload) return state;

    const filteredTasks = state.all.filter(item => !isQTask(item));
    return {
      ...state,
      all: [...filteredTasks, ...action.payload],
    };
  });

  builder.addCase(deleteHouseholdTaskActivity, (state, action) => {
    if (!action.payload) return state;
    return {
      ...state,
      all: state.all.filter(item => {
        if ('id' in item) {
          return !action.payload.some(payloadItem => payloadItem.id === item.id);
        } else {
          return true;
        }
      }),
    };
  });

  builder.addCase(resetHouseholdActivities, state => ({ ...state, all: [] }));
});
